import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { DataGrid, GridColumns, GridRowsProp } from "@mui/x-data-grid";

import TextField from "@mui/material/TextField";

/*  T O O L B A R  */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";

/*  T O O L T I P  */
import Tooltip from "@mui/material/Tooltip";

/* G R I D  */
import Grid from "@mui/material/Grid";

/* C U S T O M I Z A D O  S */
import ProjetosTopo from "./topo";
import Projeto from "../../components/classes/Projeto";
import ProjetoDataset from "../../components/data/ProjetoDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import PageHelper from "../../helper/pageHelper";

import Button from "@mui/material/Button";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { UserContext } from "../../App";

import styles from "./detail.module.css";

import { useTranslation } from "react-i18next";
import { ButtonGroup, Icon } from "@mui/material";

interface Data {
  id: number;
  nome: string;
}

export const ProjetoDetalhe = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);
  // const [nada, SetNada] = useState<Projeto[]>([]); // Unused

  const [projetos, setProjetos] = useState<Projeto[]>([]);
  const [registro, setRegistro] = useState<Projeto>(() => new Projeto());
  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<Projeto>(
    () => new Projeto()
  );
  const data: ProjetoDataset = new ProjetoDataset();

  const [habilita, setHabilita] = useState(false);
  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(true);

  const [loading, setloading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [columns, setColumns] = useState<GridColumns>([]);
  const [rows, setRows] = useState<Data[]>([]);

  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);

  function createData(id: number, nome: string): Data {
    return {
      id,
      nome,
    };
  }

  useEffect(() => {
    setloading(true);
    data.ListarAtivos().then((result) => {
      setProjetos(result);
      setloading(false);
      if (result.length > 0) {
        MontaColunas();
        preencherGrid(result);
      }
    });
  }, []);

  const handleClickNew = () => {
    console.log("handleClickNew");
    setHabilita(true);
    setRegistro(new Projeto());
  };

  const handlerNomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRegistro((previousState) => {
      return { ...previousState, nome: e.target.value };
    });
  };

  const handleIncluirClick = () => {
    var projetoToAdd = new Projeto();
    projetoToAdd.nome = registro.nome;
    data.Adicionar(projetoToAdd);
    Mensagem(t("common.warning"), t("pages.projects.text.successNewProject"));
    handleClickNew();
    setHabilita(false);
  };

  const handleAtualizaClick = () => {
    var projetoToUpd = new Projeto();
    projetoToUpd.nome = registro.nome;
    projetoToUpd.id = registro.id;
    data.Atualizar(projetoToUpd);
    Mensagem(
      t("common.warning"),
      t("pages.projects.text.successUpdateProject")
    );
    handleClickNew();
    setHabilita(false);
  };

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      setItemExcluir(projetos.filter((f) => f.id === cellValues.row.id)[0]);
      handleClickOpen();
    }
  };

  useEffect(() => {
    if (excluiItem === true) {
      data.Apagar(itemToExcluir);
      localStorage.removeItem("ProjetoIdSel");
      setMensagem(t("pages.projects.text.projectExclusionWithSuccess"));
      setSeverity(0);
      PageHelper.refreshPage();
    }
    setExcluiItem(false);
    setItemExcluir(new Projeto());
    setRefresh(!refresh);
  }, [excluiItem]);

  const handleSelectionChange = (id: any) => {
    if (id !== null && id !== undefined && id > 0) {
      localStorage.setItem("projetoIdSel", id);
      // eslint-disable-next-line array-callback-return
      projetos.map(function (item: Projeto) {
        if (item.id === Number(id)) {
          setRegistro(item);
          setHabilita(true);
        }
      });
    } else {
      localStorage.removeItem("projetoIdSel");
      setHabilita(false);
    }
  };

  function preencherGrid(_itens: Projeto[]) {
    setRows(
      _itens.map((_Item: Projeto) => {
        return createData(Number(_Item.id), String(_Item.nome));
      })
    );
    setloading(false);
  }

  function TransitionAlerts(_severity: number, _mensagem: string) {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  }

  function MontaColunas() {
    let columns1: GridColumns = [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "nome",
        headerName: t("common.name"),
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "deleteico",
        headerName: "",
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        align: "center",
        renderCell: () => {
          return (
            <IconButton disabled={user.isSuporte}>
              {" "}
              <EraseIcon />
            </IconButton>
          );
        },
      },
    ];
    setColumns(columns1);
  }

  return (
    <div className={`container ${styles.container}`}>
      <ProjetosTopo />

      <div className="insiderContainer">
        <Grid container style={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={6}>
            {habilita && (
              <TextField
                required
                id={"nome"}
                name={"Nome"}
                label={t("pages.projects.text.projectName")}
                variant="outlined"
                fullWidth
                value={registro.nome}
                onChange={handlerNomeChange}
                disabled={!habilita}
              />
            )}
          </Grid>
          <ButtonGroup>
            <Tooltip title={t("pages.projects.text.newProject")}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleClickNew}
                disabled={user.isSuporte}
                style={{ marginRight: 10 }}
              >
                <IconButton>
                  <NewIcon color="action" />
                </IconButton>
                {t("global.button.new")}
              </Button>
            </Tooltip>
            {registro.nome.length > 0 ? (
              <Tooltip title={t("pages.projects.text.updateProjectData")}>
                <span>
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={
                      registro.id === 0
                        ? handleIncluirClick
                        : handleAtualizaClick
                    }
                    disabled={user.isSuporte}
                  >
                    <IconButton>
                      <SaveIcon color="action" />
                    </IconButton>
                    {t("global.button.save")}
                  </Button>
                </span>
              </Tooltip>
            ) : null}
          </ButtonGroup>
        </Grid>
        <br />
      </div>
      <div className={styles.table}>
        <>
          <div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {t("pages.projects.text.excludeItemQuestionTitle")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t("pages.projects.text.excludeItemQuestionSubTitle")}
                  <br />
                  <br />
                  {t("pages.projects.text.project")}:{" "}
                  <strong>
                    {itemToExcluir.nome}
                    <strong />
                  </strong>
                  <br />
                  {t("pages.projects.text.excludeItemQuestionConfirmation")}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  onClick={() => {
                    setExcluiItem(true);
                    handleClose();
                  }}
                >
                  {t("common.yes")}
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleClose}
                  autoFocus
                >
                  {t("common.no")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div className={styles.table}>
            <DataGrid
              loading={loading}
              rows={rows}
              rowsPerPageOptions={[50, 100, 250, 500]}
              columns={columns}
              experimentalFeatures={{ newEditingApi: true }}
              onSelectionModelChange={(ids) => {
                handleSelectionChange(ids);
              }}
              key="ContratoItemGrid"
              rowHeight={32}
              onCellClick={(cellValues) => {
                handleClick(cellValues);
              }}
            />
            {mensagem.length > 0 ? TransitionAlerts(severity, mensagem) : null}
          </div>
        </>
      </div>
    </div>
  );
};
